import {useTranslation} from "react-i18next";
import {useMemo} from "react";

import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import MenuButtons from "components/MenuButtons";


const MainAdvanced = () => {
    const {t} = useTranslation("routes");
    const bread = useMemo(() => [
        {name: t("labels.advanced"), current: true},
    ], [t]);

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread}/>
            <MenuButtons navs={navs}/>
        </>
    )
}
export default MainAdvanced;